import React, { PureComponent } from 'react'
import moment from 'moment'
import Modal from 'react-bootstrap/lib/Modal'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'

import tracking from '../actions/tracking'
import SVGSpyglass from '../components/atoms/SVGSpyglass'

import Calendar from './Discovery/Calendar'

import BrandContext from '../contexts/BrandContext'

class DiscoveryModal extends PureComponent {
  renderSummary () {
    if (this.props.isLoading) return <FormattedMessage id='availability.flexibleDatesModalHeaderLoading' />
    if (this.props.error) return <FormattedMessage id='common.anErrorHasOccurred' />
    if (this.props.noPackages) return <div>No packages available for {moment(this.props.bounds.currentMonth).format('MMMM YYYY')}</div>
    const discoveryModalHeadingWithTickets = this.context.brandConfig.secure.hasFeatures.availability.discoveryModalHeading
    const discoveryModalHeadingWithoutTickets = this.context.brandConfig.secure.hasFeatures.availability.discoveryModalHeadingWithoutTickets
    let messageId = 'availability.flexibleDatesModalHeaderNoAvail'
    let hotelName = null
    if (this.props.hotelName) {
      messageId = 'availability.flexibleDatesModalHeaderDefault'
      if (discoveryModalHeadingWithoutTickets) messageId = 'availability.flexibleDatesModalHeaderWithoutTickets'
      if (discoveryModalHeadingWithTickets) messageId = 'availability.flexibleDatesModalHeaderWithTickets'

      hotelName = this.props.hotelName.startsWith('The') ? this.props.hotelName : `the ${this.props.hotelName.replace('the ', '')}`
    }
    return (
      <FormattedMessage
        id={messageId}
        values={{
          checkInDate: this.props.bounds.currentMonth.format('MMMM'),
          hasEventEntry: this.props.hasEventEntry,
          hotelPartyString: this.props.hotelPartyString,
          hotelName: hotelName,
          stayLength: this.props.nights,
          ticketName: this.props.ticketName,
          venueName: this.props.venueName
        }}
      />
    )
  }

  render () {
    return (
      <Modal
        className='price-finder'
        onHide={this.props.toggleVisible}
        show={this.props.isVisible}
      >
        <Modal.Header className='bg-brand' closeButton>
          <Modal.Title>
            <span className='pr-2'><SVGSpyglass width='30' height='30' aria-hidden='true' role='presentation' /></span>
            <FormattedMessage id='common.dealFinder' />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='flexible-prices-modal-summary'>
          <h4 className='m-0 flexible-prices-summary-heading'>
            {this.renderSummary()}
          </h4>
        </Modal.Body>
        <Modal.Body className='flexible-prices-modal-calendar'>
          <Calendar />
        </Modal.Body>
      </Modal>
    )
  }
}

DiscoveryModal.contextType = BrandContext

function mapStateToProps (state) {
  return {
    bounds: state.discovery.bounds,
    error: state.discovery.error,
    hasEventEntry: state.discovery.hasEventEntry,
    hotelName: (state.packageRates.packages.find(pkg => pkg.id === state.discovery.hotelId) || {}).name,
    hotelPartyString: state.basket.hotelPartyString,
    isLoading: state.discovery.isLoading,
    isVisible: state.modal.visible.discoveryCalendar,
    nights: state.discovery.nights,
    noPackages: state.discovery.packagesCount === 0,
    ticketName: state.summary.title,
    venueName: state.discovery.venueName
  }
}

function mapDispatchToProps (dispatch) {
  return {
    toggleVisible: () => {
      dispatch(tracking.track('close', 'discovery-modal', 'close'))
      return dispatch({
        type: 'MODAL_TOGGLE',
        modalName: 'discoveryCalendar'
      })
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DiscoveryModal)
export {
  DiscoveryModal
}
